import { defineMessages } from 'react-intl';

export default defineMessages({
  cancel: {
    id: 'cancel',
    defaultMessage: 'Cancel',
  },
  submit: {
    id: 'submit',
    defaultMessage: 'Submit',
  },
  continue: {
    id: 'continue',
    defaultMessage: 'Continue',
  },
});
